import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import OnboardingHeader from '../onboarding/OnboardingHeader';
import { spaces } from '../../assets/styles/themes/tokens';
import useRouter from '../../utils/useRouter';
import { routes } from '../../constants';

const ChangeEmailSuccess = () => {
  const { t } = useTranslation();
  const { router } = useRouter();

  return (
    <Box
      data-testid='change-email-success'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: spaces.xxxl,
      }}
    >
      <OnboardingHeader 
        title={t('Email address successfully changed')} 
        subtitle={t('Email address change success')}
      />
      <Button
        fullWidth
        variant='contained'
        size='large'
        color='primary'
        onClick={() => router.push(`/${routes.login.root}`)}
      >
        {t('Back to meinUnterricht')}
      </Button>
    </Box>

  );
};

export default ChangeEmailSuccess;
